// @flow
import React, { Component } from 'react';
import { CommonActions } from 'store/actionCreators';
import type { State } from 'store';
import { connect } from 'react-redux';
import { type TagData } from 'store/modules/common';
import ProductsTagItemList from 'components/tags/ProductsTagItemList/ProductsTagItemList';

type OwnProps = {
  sort: string,
};

type Props = OwnProps & {
  tags: ?(TagData[]),
  shouldCancel: boolean,
};

class ProductsTagItemListContainer extends Component<Props> {
  initialize = () => {
    const { sort, shouldCancel } = this.props;
    if (shouldCancel) return;
    CommonActions.getProductsTags(sort);
  };

  componentDidMount() {
    this.initialize();
  }

  onSelectTag = (info: TagData) => {
    CommonActions.setProductsTagInfo(info);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.initialize();
    }
  }

  render() {
    const { tags } = this.props;
    return <ProductsTagItemList tags={tags} onSelectTag={this.onSelectTag} />;
  }
}

export default connect(
  ({ common }: State) => ({
    tags: common.productsTags.data,
    shouldCancel: common.ssr && !common.router.altered,
  }),
  () => ({}),
)(ProductsTagItemListContainer);



// WEBPACK FOOTER //
// ./src/containers/tags/ProductsTagItemListContainer.js